import { escapeHtml as esc } from './escapeHtml'

export function renderMessagePreview (cleanedText) {
  return cleanedText ? `<div class="card-msg">${esc(cleanedText)}</div>` : ''
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/messageCardPreview.js